/*
 *  Document   : candidate-professions.js
 *  Author     : Exapoint
 *
 */

// Import required modules
import Helpers from './../exa_helpers';
import ExaHelpers from './../exa_helpers';
import Fuse from "fuse.js";

// Tools
export default class CandidateProfessions {
    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["CandidateProfessions"] = this;
        this.init();
    }

    /*
     * Updates the color theme
     *
     */
    init() {
        let app = this;
        let $professionsEditModal = $('#professions-edit-modal');
        app.$professionsEditModal = $professionsEditModal;
        app.reloadAfterCloseModal = false;

        if (jsVars.showFelicitationAlert) {
            this.showFelicitationAlert();
        }

        let professionsTable = $('table.professions').DataTable({
            lengthChange: false,
            info: false,
            ordering: false,
            searching: false,
            responsive: true,
            language: {
                url: Laravel.datatablesLanguage
            },
        });
        app.professionsTable = professionsTable;
        app.$professionsForm = $('#professions-form');

        $professionsEditModal.on('show.bs.modal', function (e) {
            let $modal = $(e.target);
            let $target = $(e.relatedTarget).first();
            if ($target.length === 0) {
                console.log('Error! Cant find related target.');
                return;
            }

            let $tr = $target.closest('tr').hasClass('child') ? $target.closest('tr').prev() : $target.closest('tr');
            let $inputs = $tr.find('[name]');
            $inputs.each(function (i, el) {
                let $el = $(el);
                let fieldName = Helpers.extractFieldFromName(el.name);
                let $input = $modal.find(`[name="${fieldName}"]`);

                if ($input.length !== 0) {
                    Helpers.applyInputValue($input, $el);
                    $input.data('originalName', el.name);
                }
            });

            let $closestTr = $target.closest('tr');
            if ($closestTr.hasClass('child')) {
                $closestTr = $closestTr.siblings('tr.parent');
            }

            let changePossible = app.$professionsEditModal.find('[name="change_possible"]').val();
            if (changePossible === "true") {
                app.$professionsEditModal.find('.block-content').first().prepend($(
                    `<div class="profession-modal-autocomplete">
                        <label for="">${jsVars.professionText}</label><br>
                        <div class="form-group toggle">
                            <span class="profession-name"></span>
                            <button class="btn btn-sm float-right btn-primary p-2 toggle-button">${jsVars.changeProfessionText}</button>
                        </div>
                        <div class="form-group toggle" style="display: none">
                            <input class="form-control" id="jobTitlesAutocomplete-modal" placeholder="${jsVars.changeProfession}" type="text" autocomplete="off">
                        </div>
                    </div>
                `));

                let $jtAc = app.$professionsEditModal.find('#jobTitlesAutocomplete-modal');
                app.initModalAutocomplete($jtAc);
            } else {
                app.$professionsEditModal.find('.block-content').first().prepend($(
                    `<div class="profession-modal-autocomplete">
                        <label for="">${jsVars.professionText}</label><br>
                        <div class="form-group toggle">
                            <span class="profession-name"></span>
                        </div>
                    </div>
                `));
            }

            $modal.find('.profession-name').text($closestTr.find('td:first').text().trim());
            let $experienceInput = $modal.find('[name="job_title_experience_id"]');
            if (!$experienceInput.val() || $experienceInput.val() === '') {
                $experienceInput.find('option:first-child').prop('selected', true);
            }
        });

        // Every time modal hides
        $professionsEditModal.on('hidden.bs.modal', function (e) {
            setTimeout(function () {
                professionsTable.rows().invalidate('dom') && professionsTable.draw(false);

                let $jtAc = app.$professionsEditModal.find('.profession-modal-autocomplete');
                if ($jtAc.length) {
                    $jtAc.remove();
                }

                if (app.reloadAfterCloseModal) {
                    app.reloadAfterCloseModal = false;
                    app.$professionsForm.submit();
                    app.$professionsForm.find('[type="submit"]').prop('disabled', true);
                }
            }, 1);
        });

        // When button confirm is clicked
        $professionsEditModal.find('[type="submit"].btn-confirm').on('click', function (e) {
            e.preventDefault();
            let $modal = $(e.target).closest('.modal');
            let $form = $modal.find('form');

            if (!$form.valid()) {
                return;
            }
            app.reloadAfterCloseModal = true;

            let $inputs = $modal.find('[name]');
            let $singleInput;
            $inputs.each(function (i, el) {
                let $el = $(el);
                let $input = $(`tr:not(.child) [name="${$el.data('originalName')}"]`);
                $singleInput = $input;

                if ($input.length !== 0) {
                    Helpers.applyInputValue($input, $el);
                }
            });

            let $el = $modal.find('[name="candidate_rate"]');
            if ($el.length !== 0) {
                let $candidateRateInput = $(`tr:not(.child) [name="${$el.data('originalName')}"]`);
                Helpers.applyInputValue($candidateRateInput, $el);

                if ($candidateRateInput.val() === "" && $candidateRateInput.parent().find('.select-label').length !== 0) {
                    $candidateRateInput.parent().find('.select-label').html(`${jsVars.currentPricingText} <i class="far fa-question-circle" data-toggle="tooltip" title="${jsVars.priceNotSetLabel}"></i>`);
                }
            }

            $modal.modal('hide');

            let $jtAc = app.$professionsEditModal.find('#jobTitlesAutocomplete-modal');
            if ($jtAc.length) {
                let label = $jtAc.val();
                let value = $jtAc.data('value');

                if (typeof value === "undefined") {
                    return;
                }

                let oldJobTitleId = app.$professionsEditModal.find('[name="job_title_id"]').val();

                $(`[name*="userable[jobTitles][${oldJobTitleId}]"]`).each(function (_i, val) {
                    val.name = val.name.replace(`userable[jobTitles][${oldJobTitleId}]`, `userable[jobTitles][${value}]`);
                })
                let $jobTitleId = $(`[name="userable[jobTitles][${value}][job_title_id]"]`);
                $jobTitleId.val(value);
                $jobTitleId.parents('tr').find('.job-title-name').html(label);

                app.$professionsEditModal.find('[name="job_title_id"]').val(value);
                app.$professionsEditModal.find('[name]').each(function (_i, val) {
                    let $el = $(val);
                    $el.data('originalName', $el.data('originalName').replace(`userable[jobTitles][${oldJobTitleId}]`, `userable[jobTitles][${value}]`));
                })

                app.updateAcValues();
            }
        });

        var swal = Swal.mixin({
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-success m-1",
                cancelButton: "btn btn-danger m-1",
                input: "form-control"
            }
        });

        // When button cancel is clicked
        $professionsEditModal.find('.btn-delete').on('click', function (e) {
            e.preventDefault();
            let $modal = $(e.target).closest('.modal');

            swal.fire({
                title: jsVars.confirmActionTitle,
                text: jsVars.confirm_delete_text,
                icon: "warning",
                showCancelButton: !0,
                customClass: {confirmButton: "btn btn-danger m-1", cancelButton: "btn btn-secondary m-1"},
                confirmButtonText: jsVars.confirmButtonText,
                cancelButtonText: jsVars.cancelButtonText,
                html: !1,
                preConfirm: function (e) {
                    let $inputs = $modal.find('[name]');

                    let value = $modal.find('[name="job_title_id"]').val();
                    let indexToAdd = app.removedAcItems.findIndex(x => x.id === parseInt(value));
                    if (indexToAdd !== -1) {
                        app.fuse.add(app.removedAcItems[indexToAdd]);
                    }

                    $inputs.each(function (i, el) {
                        let $el = $(el);
                        let $input = $(`[name="${$el.data('originalName')}"]`);

                        if ($input.length !== 0) {

                            let $tr = $input.closest('tr').hasClass('child') ? $input.closest('tr').prev() : $input.closest('tr');
                            professionsTable.row($tr).remove();
                            return false;
                        }
                    });
                    $modal.modal('hide');
                }.bind(this)
            }).then((function (n) {
                app.reloadAfterCloseModal = true;
                n.value ?
                    swal.fire(jsVars.confirmActionSuccess, '', "success") && $modal.modal('hide') :
                    "cancel" === n.dismiss;
            }))
        });

        this.$professionsEditModal.on('click', '.toggle-button', function (e) {
            let $target = $(e.target);
            $target.parents('.form-group').parent().find('.toggle').toggle();
        })

        this.initJobTitlesAutocomplete();
        this.initProfessionCertificateFilesDropzone();
        this.initValidation();
    }

    professionsEditRowTemplate(datarecord, idx) {
        let rowColumns = [];

        // Profession
        rowColumns.push(`
            <span class="job-title-name">${datarecord.text ? datarecord.text : datarecord.genderNeutral}</span>
            <input name="userable[jobTitles][${datarecord.id}][]" type="hidden">
            <input name="userable[jobTitles][${datarecord.id}][job_title_id]" type="hidden" value="${datarecord.id}">
            <input name="userable[jobTitles][${datarecord.id}][certificate_files]" type="hidden" value="[]">
            <input name="userable[jobTitles][${datarecord.id}][change_possible]" type="hidden" value="true">
            <input name="userable[jobTitles][${datarecord.id}][other_missions]"  type="checkbox" value="true" style="display: none;">
            <input name="userable[jobTitles][${datarecord.id}][worked_in_ch]" type="checkbox" value="true" style="display: none;" >
        `);
        // Experience
        rowColumns.push(`
            <span class="select-label text">${jsVars.minimalExperienceLabel}</span>
            <select style="display: none;" name="userable[jobTitles][${datarecord.id}][job_title_experience_id]"></select>
        `);

        // Has Certificate
        rowColumns.push(`
                ${boolButtonFalse}
                <input style="display: none;" name="userable[jobTitles][${datarecord.id}][has_certificate]" type="checkbox" value="true">
            `);

        // Active
        rowColumns.push(`
                ${boolButtonFalse}
                <input style="display: none;" name="userable[jobTitles][${datarecord.id}][active]" type="checkbox" value="true">
            `);

        // Status
        if (CandidateProfessions.consultant) {
            rowColumns.push(CandidateProfessions.consultant.statusColumn(datarecord));
        }

        if (!CandidateProfessions.consultant) {
            rowColumns.push(`${jsVars.currentPricingText} <i class="far fa-question-circle" data-toggle="tooltip" title="${jsVars.priceNotSetLabel}"></i>`);
        } else {
            rowColumns.push(CandidateProfessions.consultant.priceColumn(datarecord));
        }

        rowColumns.push(`
             <div class="btn-group">
                <span data-toggle="modal" data-target="#professions-edit-modal">
                    <div class="btn btn-outline-primary btn-small" data-toggle="tooltip" title="${jsVars.editText}">
                        ${jsVars.editText}
                    </div>
                </span>
            </div>
        `);

        return rowColumns;
    }

    initJobTitlesAutocomplete() {
        let app = this;
        app.removedAcItems = [];

        app.fuse = new Fuse(jsVars.jobTitlesAutocomplete, {
            minMatchCharLength: 3,
            threshold: 0.3,
            distance: 1000,
            keys: ["genderNeutral"],
            getFn: (obj, path) => {
                return obj.genderNeutral.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            }
        })

        let $jtAc = $("#jobTitlesAutocomplete");

        this.updateAcValues();

        $jtAc.autocomplete({
            delay: 0,
            minLength: 2,
            source: function (req, callback) {
                let term = req.term.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

                let options = [];
                $.each(app.fuse.search(term, {limit: 10}), function (index, obj) {
                    options.push({value: obj.item.id, label: obj.item.genderNeutral, wholeObject: obj.item});
                });

                callback(options);
            },
            select: function (event, ui) {
                var label = ui.item.label;
                var value = ui.item.value;

                let indexToRemove = app.fuse._docs.findIndex(x => x.id === parseInt(value));
                if (indexToRemove !== -1) {
                    app.removedAcItems.push(app.fuse._docs[indexToRemove]);
                    app.fuse.removeAt(indexToRemove);
                }

                let newValue = ui.item.wholeObject;

                let newRow = app.professionsTable.row.add(app.professionsEditRowTemplate(newValue, null)).draw(true);

                app.professionsTable.responsive.recalc();

                // Load bootstrap tooltips for the new rows
                Dashmix.helpers('core-bootstrap-tooltip');

                let $rowNode = $(app.professionsTable.row(newRow.index()).node());
                $rowNode.find('[data-target="#professions-edit-modal"]').click();

                $(this).val('');
                return false;
            },
            focus: function (event, ui) {
                $(this).val(ui.item.label);
                return false;
            }
        });
    }

    initModalAutocomplete($jtAc) {
        let app = this;
        $jtAc.autocomplete({
            delay: 0,
            minLength: 2,
            source: function (req, callback) {
                let term = req.term.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

                let options = [];
                $.each(app.fuse.search(term, {limit: 10}), function (index, obj) {
                    options.push({value: obj.item.id, label: obj.item.genderNeutral, wholeObject: obj.item});
                });

                callback(options);
            },
            select: function (event, ui) {
                var label = ui.item.label;
                var value = ui.item.value;

                $(this).val(label);
                $(this).data('value', value);
                return false;
            },
            focus: function (event, ui) {
                $(this).val(ui.item.label);
                return false;
            }
        });
    }

    updateAcValues() {
        let app = this;

        let selectedValues = [];
        $('[name*="userable[jobTitles]"]').each(function (_i, val) {
            let parsedId = parseInt(ExaHelpers.extractFieldFromName($(val).prop('name')));
            if (!isNaN(parsedId)) {
                selectedValues.push(parsedId);
            }
        })

        $.each(selectedValues, function (_i, value) {
            let indexToRemove = app.fuse._docs.findIndex(x => x.id === parseInt(value));
            if (indexToRemove !== -1) {
                app.removedAcItems.push(app.fuse._docs[indexToRemove]);
                app.fuse.removeAt(indexToRemove);
            }
        })
    }

    initProfessionCertificateFilesDropzone() {
        this.$jobTitleCertificateFiles = $('#job-title-certificate-files-dropzone');

        // Every time modal hides
        this.$professionsEditModal.on('hidden.bs.modal', function (e) {
            this.$jobTitleCertificateFiles.get(0).dropzone.destroy();
        }.bind(this));

        // Every time modal is opened
        this.$professionsEditModal.on('show.bs.modal', function (e) {
            if (this.$jobTitleCertificateFiles.hasClass('dropzone') && this.$jobTitleCertificateFiles.get(0).dropzone) {
                this.$jobTitleCertificateFiles.get(0).dropzone.destroy();
            }
            this.$jobTitleCertificateFiles.addClass('dropzone');
            let jobTitleId = this.$jobTitleCertificateFiles.parents('.modal').find('[name="job_title_id"]').val();
            this.$jobTitleCertificateFiles.dropzone(
                {
                    url: jsVars.saveCertificateFileUrl.replace(':job-title-id', jobTitleId),
                    init: function () {
                        let thisDropzone = this;
                        let $thisElement = $(thisDropzone.element);

                        thisDropzone.inputField = $thisElement.find('input');
                        thisDropzone.modelId = $thisElement.parents('.modal').find('[name="job_title_id"]').val();
                        thisDropzone.modelId = typeof thisDropzone.modelId === "undefined" ? '' : thisDropzone.modelId;

                        thisDropzone.preloadedFiles = [];
                        if (thisDropzone.inputField.length !== 0) {
                            thisDropzone.preloadedFiles = thisDropzone.inputField.val();
                            thisDropzone.preloadedFiles = JSON.parse(thisDropzone.preloadedFiles);
                        }

                        $.each(thisDropzone.preloadedFiles, function (key, value) {
                            if (!value) {
                                return;
                            }
                            let file = {
                                processing: true,
                                accepted: true,
                                name: value.originalName,
                                size: value.size,
                                type: value.mimeType,
                                status: Dropzone.SUCCESS,
                                downloadLink: value.path,
                                dbData: value,
                            };
                            thisDropzone.files.push(file);
                            thisDropzone.emit("addedfile", file);
                            if (value.thumbnail) {
                                thisDropzone.emit("thumbnail", file, Laravel.app_url + value.thumbnail);
                            }
                            thisDropzone.emit("processing", file);
                            thisDropzone.emit("success", file, {status: "success"}, false);
                            thisDropzone.emit("complete", file);
                            file.path = value.path;
                        });

                        $thisElement.on('click', '[data-dz-name]', function (e) {
                            let $target = $(e.target);
                            let $fileContainer = $target.parents('.dz-preview');
                            let downloadLink = $fileContainer.find('.dz-file-download-link').val();

                            window.open(Laravel.app_url + '/storage/' + downloadLink, '_blank');
                        });

                        thisDropzone.on("removedfile", function (file) {
                            this.inputField.val(JSON.stringify(this.files.map(a => a.dbData)));
                        });

                        thisDropzone.on("addedfile", function (file) {
                            $thisElement.parents('.modal').find('button').prop('disabled', true);
                        });

                        thisDropzone.on("complete", function (file) {
                            $thisElement.parents('.modal').find('button').prop('disabled', false);
                        });
                    },
                    sending: function (file, xhr, formData) {
                        formData.append("_token", Laravel.csrfToken);
                        formData.append("id", this.modelId);
                        // formData.append("candidateId", jsVars.candidateId);
                    },
                    success: function (file, response) {
                        if (typeof response.uploadedFile !== "undefined") {
                            // This is an ajax response
                            file.path = response.uploadedFile.path;
                            file.dbData = response.uploadedFile;
                            this.inputField.val(JSON.stringify(this.files.map(a => a.dbData)));
                        }
                        let link = file.downloadLink || file.path;
                        if (link) {
                            // Save download link to hidden input for click to open to work
                            file.previewTemplate.insertAdjacentHTML('beforeend',
                                `<input type="hidden" class="dz-file-download-link" value="${link}" />`);
                        }
                        if (typeof response.uploadedFile !== "undefined") {
                            $(file.previewElement).addClass("dz-success");
                            setTimeout(function () {
                                $(file.previewElement).removeClass("dz-success");
                            }, 2750);

                            Dashmix.helpers('notify', {
                                align: 'center',
                                type: 'success',
                                icon: 'fa fa-check mr-1 mt-5 mb-5',
                                message: jsVars.fileUploadedSuccessTab
                            });
                        }
                    },
                    error: function (file, message) {
                        $(file.previewElement).addClass("dz-error");
                        if (message.errors) {
                            $(file.previewElement).find('.dz-error-message').text(message.errors.file);
                        }
                    },
                    addRemoveLinks: true,
                }
            );

        }.bind(this));
    }

    initValidation() {
        this.$professionsEditModal.find('form').validate({
            ignore: [],
            rules: {
                'candidate_rate': {
                    number: true
                },
            },
        });
    }

    showFelicitationAlert(){
        let e = Swal.mixin({
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-success m-1",
                // cancelButton: "btn btn-danger m-1",
                input: "form-control"
            }
        });

        e.fire({
            title: '',
            text: '',
            icon: "success",
            showCancelButton: 0,
            customClass: {
                confirmButton: "btn btn-primary m-1",
                // cancelButton: "btn btn-danger m-1"
            },
            confirmButtonText: jsVars.closeText,
            // cancelButtonText: false,
            html: jsVars.showFelicitationsText,
        })
    }
}
